export default "__VITE_ASSET__27f7e27f__"